import { render } from "./DeleteCharter.vue?vue&type=template&id=facc3780"
import script from "./DeleteCharter.vue?vue&type=script&lang=js"
export * from "./DeleteCharter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__